// interface for environment configuration
interface EnvConfig {
  [key: string]: {
    apiBaseUrl: string;
    appBaseUrl: string;
    aemBaseUrl: string;
    didYouKnowUrl: string;
    legacyDiscoverDetailPath: string;
    dataExplorerDetailPath: string;
    legacyDiscoverVideoPath: string;
    teamsPath: string;
    discoverHeader: string;
    discoverFooter: string;
    intranetHeader: string;
    intranetFooter: string;
    aemScope: string;
    auth: {
      [key: string]: string;
    };
    dataPrivacy: {
      label: string;
      url: string;
    };
    search: {
      [key: string]: string;
    };
    smarthub: {
      [key: string]: string;
    };
    customApi: {
      [key: string]: any;
    };
    smartPreview: {
      [key: string]: string;
    };
    webcomponent: {
      [key: string]: string;
    };
    aemPreviewStats: string;
    aemBrowseAPI: string;
    ontology: {
      BaseUrl: string;
      limitBy: string[];
    };
    isShowNewsVertical?: boolean;
    intranetHostName: string[];
    sharepointHosts: string[];
    isToggleAISearchEnabled: boolean;
    adobeSDKUrl: string;
    aemPDFRenditionServlet: string;
    adobeClientId: string;
    forceKeywordSearchPeople?: boolean;
    forceKeywordSearchNews?: boolean;
  };
}

/**
 * environment configurations
 *
 * apiBaseUrl: api endpoint base url
 * appBaseUrl: hosted domain
 * auth: authentication config specific to each environment
 * search: search endpoint sourceId
 * export {
 *   envConfig
 * }
 */
const envConfig: EnvConfig = {
  local: {
    //apiBaseUrl: 'https://localhost:7268',
      apiBaseUrl: 'https://api.discovernw-qa.ey.com/discoversearchdev',
    appBaseUrl: 'http://localhost:3000',
    aemBaseUrl: 'https://dev-discovercontent.ey.net',
    ontology: {
      BaseUrl: 'https://api.discovernw-qa.ey.com/dev-pp-search',
      limitBy: ['limitby']
    },
    didYouKnowUrl:
      'https://dev-discovercontent.ey.net/bin/eyd/aaoc/service/xf/did-you-know?landingPage=search',
    legacyDiscoverDetailPath:
      'https://find.ey.net/test/discovertest/sitepages/home.aspx?detailPath=',
    dataExplorerDetailPath: 'https://data-dev.discover.ey.com/#/details?src=',
    legacyDiscoverVideoPath:
      'https://find.ey.net/test/discovertest/sitepages/video.aspx?detailPath=',
    teamsPath: 'https://teams.microsoft.com/l/chat/0/0?users=',
    discoverHeader:
      'https://dev-discovercontent.ey.net/bin/eyd/aaoc/service/xf/header',
    discoverFooter:
      'https://dev-discovercontent.ey.net/bin/eyd/aaoc/service/xf/footer',
    intranetHeader:
      'https://dev-intranet.ey.com/bin/eyd/aaoc/service/xf/header/intranet',
    intranetFooter:
      'https://dev-intranet.ey.com/bin/eyd/aaoc/service/xf/footer/intranet',
    aemScope: 'f3ccf5e6-fdc8-49ea-8d34-d6f8f1c100c0/AEM.AAOC.Read',
    auth: {
      clientId: 'd40a7dbd-ef67-481f-9294-258ff80fbc9f',
      tenantId: '5b973f99-77df-4beb-b27d-aa0c70b8482c'
    },
    dataPrivacy: {
      label: 'Data Privacy',
      url: 'https://discovercontent.ey.net/content/cms/home-page/privacy-policy.html'
    },
    search: {
      sourceId: 'b29924a9-ec32-4c10-8892-a544b69ee121'
    },
    smarthub: {
      apiScope: 'd2d37b4b-1f70-466e-a2d6-d3b7e0a46668/SmartHub_Site_Scope'
    },
    customApi: {
      apiScope: 'api://d40a7dbd-ef67-481f-9294-258ff80fbc9f/Api.Read.All'
    },
    smartPreview: {
      previewURL: 'https://DiscoverDocViewer-dev.ey.com'
    },
    webcomponent: {
      cssfile: 'https://discover-dev.ey.com/webcomponent/main.css',
      jsfile: 'https://discover-dev.ey.com/webcomponent/main.js'
    },
    aemPreviewStats:
      'https://dev-discovercontent.ey.net/bin/eyd/aaoc/service/read-data?pageid=$eyId',
    aemBrowseAPI:
      'https://dev-discovercontent.ey.net/bin/eyd/aaoc/service/browse?name=$name',
    isShowNewsVertical: true,
    intranetHostName: ['intranet-dev.ey.com','intranet-cms-dev.ey.com','dev-intranet.ey.com'],
    sharepointHosts: ['sites.ey.com', 'sharepoint.com'],
    isToggleAISearchEnabled: true,
    forceKeywordSearchPeople: true,
    forceKeywordSearchNews: true,
    adobeSDKUrl: 'https://acrobatservices.adobe.com/view-sdk/viewer.js',
    aemPDFRenditionServlet: '/bin/eyd/aaoc/service/assetpdfrendition',
    adobeClientId: 'c98f78c81cd94c28b5214970dd53e2fe'
  },
  development: {
    apiBaseUrl: 'https://api.discovernw-qa.ey.com/discoversearchdev',
    appBaseUrl: 'https://discover-dev.ey.com',
    aemBaseUrl: 'https://dev-discovercontent.ey.net',
    ontology: {
      BaseUrl: 'https://api.discovernw-qa.ey.com/dev-pp-search',
      limitBy: ['limitby']
    },
    didYouKnowUrl:
      'https://dev-discovercontent.ey.net/bin/eyd/aaoc/service/xf/did-you-know?landingPage=search',
    legacyDiscoverDetailPath:
      'https://find.ey.net/test/discovertest/sitepages/home.aspx?detailPath=',
    legacyDiscoverVideoPath:
      'https://find.ey.net/test/discovertest/sitepages/video.aspx?detailPath=',
    dataExplorerDetailPath: 'https://data-dev.discover.ey.com/#/details?src=',
    teamsPath: 'https://teams.microsoft.com/l/chat/0/0?users=',
    discoverHeader:
      'https://dev-discovercontent.ey.net/bin/eyd/aaoc/service/xf/header',
    discoverFooter:
      'https://dev-discovercontent.ey.net/bin/eyd/aaoc/service/xf/footer',
    intranetHeader:
      'https://dev-intranet.ey.com/bin/eyd/aaoc/service/xf/header/intranet',
    intranetFooter:
      'https://dev-intranet.ey.com/bin/eyd/aaoc/service/xf/footer/intranet',
    aemScope: 'f3ccf5e6-fdc8-49ea-8d34-d6f8f1c100c0/AEM.AAOC.Read',
    auth: {
      clientId: 'd40a7dbd-ef67-481f-9294-258ff80fbc9f',
      tenantId: '5b973f99-77df-4beb-b27d-aa0c70b8482c',
      apiScope: 'api://d40a7dbd-ef67-481f-9294-258ff80fbc9f/Feedback.ReadWrite'
    },
    dataPrivacy: {
      label: 'Data Privacy',
      url: 'https://discovercontent.ey.net/content/cms/home-page/privacy-policy.html'
    },
    search: {
      sourceId: 'b29924a9-ec32-4c10-8892-a544b69ee121'
    },
    smarthub: {
      apiScope: 'd2d37b4b-1f70-466e-a2d6-d3b7e0a46668/SmartHub_Site_Scope'
    },
    customApi: {
      apiScope: 'api://d40a7dbd-ef67-481f-9294-258ff80fbc9f/Api.Read.All'
    },
    smartPreview: {
      previewURL: 'https://DiscoverDocViewer-dev.ey.com'
    },
    webcomponent: {
      cssfile: 'https://discover-dev.ey.com/webcomponent/main.css',
      jsfile: 'https://discover-dev.ey.com/webcomponent/main.js'
    },
    aemPreviewStats:
      'https://dev-discovercontent.ey.net/bin/eyd/aaoc/service/read-data?pageid=$eyId',
    aemBrowseAPI:
      'https://dev-discovercontent.ey.net/bin/eyd/aaoc/service/browse?name=$name',
    isShowNewsVertical: true,
    intranetHostName: ['intranet-dev.ey.com','intranet-cms-dev.ey.com','dev-intranet.ey.com'],
    sharepointHosts: ['sites.ey.com', 'sharepoint.com'],
    isToggleAISearchEnabled: true,
    forceKeywordSearchPeople: true,
    forceKeywordSearchNews: true,
    adobeSDKUrl: 'https://acrobatservices.adobe.com/view-sdk/viewer.js',
    aemPDFRenditionServlet: '/bin/eyd/aaoc/service/assetpdfrendition',
    adobeClientId: '9e278a7f3fd944d2a3116404b4f23e61'
  },
  qa: {
    apiBaseUrl: 'https://api.discovernw-qa.ey.com/discoversearch',
    appBaseUrl: 'https://discover-qa.ey.com',
    aemBaseUrl: 'https://discovercontent-qa.ey.net',
    ontology: {
      BaseUrl: 'https://api.discovernw-qa.ey.com/qa-pp-search',
      limitBy: ['limitby']
    },
    didYouKnowUrl:
      'https://discovercontent-qa.ey.net/bin/eyd/aaoc/service/xf/did-you-know?landingPage=search',
    legacyDiscoverDetailPath:
      'https://find.ey.net/test/discovertest/sitepages/home.aspx?detailPath=',
    legacyDiscoverVideoPath:
      'https://find.ey.net/test/discovertest/sitepages/video.aspx?detailPath=',
    dataExplorerDetailPath: 'https://data-qa.discover.ey.com/#/details?src=',
    teamsPath: 'https://teams.microsoft.com/l/chat/0/0?users=',
     discoverHeader:
      'https://discovercontent-qa.ey.net/bin/eyd/aaoc/service/xf/header',
    discoverFooter:
      'https://discovercontent-qa.ey.net/bin/eyd/aaoc/service/xf/footer',
    intranetHeader:
      'https://intranet-qa.ey.com/bin/eyd/aaoc/service/xf/header/intranet',
    intranetFooter:
      'https://intranet-qa.ey.com/bin/eyd/aaoc/service/xf/footer/intranet',
    aemScope: 'e673b2b5-91a4-414e-8543-107746d9d665/AEM.AAOC.Read',
    auth: {
      clientId: 'd40a7dbd-ef67-481f-9294-258ff80fbc9f',
      tenantId: '5b973f99-77df-4beb-b27d-aa0c70b8482c',
      apiScope: 'api://d40a7dbd-ef67-481f-9294-258ff80fbc9f/Feedback.ReadWrite'
    },
    dataPrivacy: {
      label: 'Data Privacy',
      url: 'https://discovercontent.ey.net/content/cms/home-page/privacy-policy.html'
    },
    search: {
      sourceId: 'b29924a9-ec32-4c10-8892-a544b69ee121'
    },
    smarthub: {
      apiScope: 'd2d37b4b-1f70-466e-a2d6-d3b7e0a46668/SmartHub_Site_Scope'
    },
    customApi: {
      apiScope: 'api://d40a7dbd-ef67-481f-9294-258ff80fbc9f/Api.Read.All'
    },
    smartPreview: {
      previewURL: 'https://DiscoverDocViewer-dev.ey.com'
    },
    webcomponent: {
      cssfile: 'https://discover-qa.ey.com/webcomponent/main.css',
      jsfile: 'https://discover-qa.ey.com/webcomponent/main.js'
    },
    aemPreviewStats:
      'https://discovercontent-qa.ey.net/bin/eyd/aaoc/service/read-data?pageid=$eyId',
    aemBrowseAPI:
      'https://discovercontent-qa.ey.net/bin/eyd/aaoc/service/browse?name=$name',
    isShowNewsVertical: true,
    intranetHostName: ['intranet-qa.ey.com','intranet-cms-qa.ey.com'],
    sharepointHosts: ['sites.ey.com', 'sharepoint.com'],
    isToggleAISearchEnabled: true,
    forceKeywordSearchPeople: true,
    forceKeywordSearchNews: true,
    adobeSDKUrl: 'https://acrobatservices.adobe.com/view-sdk/viewer.js',
    aemPDFRenditionServlet: '/bin/eyd/aaoc/service/assetpdfrendition',
    adobeClientId: '126496e76c17433b8d4fdd8248cb5ff0'
  },
  ua: {
    apiBaseUrl: 'https://api.discovernw-uat.ey.com/discoversearch',
    appBaseUrl: 'https://discover-ua.ey.com',
    aemBaseUrl: 'https://discovercontent-stg.ey.net',
    ontology: {
      BaseUrl: 'https://api.discovernw-uat.ey.com/pp-search',
      limitBy: ['limitby']
    },
    dataPrivacy: {
      label: 'Data Privacy',
      url: 'https://discovercontent.ey.net/content/cms/home-page/privacy-policy.html'
    },
    didYouKnowUrl:
      'https://discovercontent-stg.ey.net/bin/eyd/aaoc/service/xf/did-you-know?landingPage=search',
    legacyDiscoverDetailPath:
      'https://find.ey.net/test/discovertest/sitepages/home.aspx?detailPath=',
    legacyDiscoverVideoPath:
      'https://find.ey.net/test/discovertest/sitepages/video.aspx?detailPath=',
    dataExplorerDetailPath: 'https://data-qa.discover.ey.com/#/details?src=',
    teamsPath: 'https://teams.microsoft.com/l/chat/0/0?users=',
    discoverHeader:
      'https://discovercontent-stg.ey.net/bin/eyd/aaoc/service/xf/header',
    discoverFooter:
      'https://discovercontent-stg.ey.net/bin/eyd/aaoc/service/xf/footer',
    intranetHeader:
      'https://intranet-stg.ey.com/bin/eyd/aaoc/service/xf/header/intranet',
    intranetFooter:
      'https://intranet-stg.ey.com/bin/eyd/aaoc/service/xf/footer/intranet',
    aemScope: '8b9865b7-6d18-439d-bf9a-81ff058a641a/AEM.AAOC.Read',
    auth: {
      clientId: 'b9c25dfb-c6d4-4e30-8215-c195a675c134',
      tenantId: '5b973f99-77df-4beb-b27d-aa0c70b8482c',
      apiScope: 'api://2d29ee92-c076-4dd2-b752-9efeaba64b7d/SmartHub_Site_Scope'
    },
    search: {
      sourceId: 'b29924a9-ec32-4c10-8892-a544b69ee121'
    },
    smarthub: {
      apiScope: '2d29ee92-c076-4dd2-b752-9efeaba64b7d/SmartHub_Site_Scope'
    },
    customApi: {
      apiScope: 'api://b9c25dfb-c6d4-4e30-8215-c195a675c134/Api.Read.All'
    },
    smartPreview: {
      previewURL: 'https://DiscoverDocViewer-ua.ey.com'
    },
    webcomponent: {
      cssfile: 'https://discover-ua.ey.com/webcomponent/main.css',
      jsfile: 'https://discover-ua.ey.com/webcomponent/main.js'
    },
    aemPreviewStats:
      'https://discovercontent-stg.ey.net/bin/eyd/aaoc/service/read-data?pageid=$eyId',
    aemBrowseAPI:
      'https://discovercontent-stg.ey.net/bin/eyd/aaoc/service/browse?name=$name',
    isShowNewsVertical: true,
    intranetHostName: ['intranet-stg.ey.com','intranet-cms-stg.ey.com'],
    sharepointHosts: ['sites.ey.com', 'sharepoint.com'],
    isToggleAISearchEnabled: true,
    forceKeywordSearchPeople: true,
    forceKeywordSearchNews: true,
    adobeSDKUrl: 'https://acrobatservices.adobe.com/view-sdk/viewer.js',
    aemPDFRenditionServlet: '/bin/eyd/aaoc/service/assetpdfrendition',
    adobeClientId: 'f50f440b4029443ba6df7d6831daae11'
  },
 
  
  prod: {
    apiBaseUrl: 'https://api.discovernw.ey.com/discoversearch',
    appBaseUrl: 'https://discover.ey.com',
    aemBaseUrl: 'https://discovercontent.ey.net',
    ontology: {
      BaseUrl: 'https://api.discovernw.ey.com/pp-search',
      limitBy: ['limitby']
    },
    didYouKnowUrl:
      'https://discovercontent.ey.net/bin/eyd/aaoc/service/xf/did-you-know?landingPage=search',
    legacyDiscoverDetailPath:
      'https://find.ey.net/discover/sitepages/home.aspx?detailPath=',
    legacyDiscoverVideoPath:
      'https://find.ey.net/discover/sitepages/video.aspx?detailPath=',
    dataExplorerDetailPath: 'https://data.discover.ey.com/#/details?src=',
    teamsPath: 'https://teams.microsoft.com/l/chat/0/0?users=',
    discoverHeader:
      'https://discovercontent.ey.net/bin/eyd/aaoc/service/xf/header',
    discoverFooter:
      'https://discovercontent.ey.net/bin/eyd/aaoc/service/xf/footer',
    intranetHeader:
      'https://intranet.ey.com/bin/eyd/aaoc/service/xf/header/intranet',
    intranetFooter:
      'https://intranet.ey.com/bin/eyd/aaoc/service/xf/footer/intranet',
    aemScope: 'd8189e08-8225-4287-986c-3ce29b2232b9/AEM.AAOC.Read',
    auth: {
      clientId: '8dcf0d40-7d03-4fc2-9eca-3f459b14ac67',
      tenantId: '5b973f99-77df-4beb-b27d-aa0c70b8482c',
      apiScope: 'api://0ab2f2cc-69cb-43e1-94eb-c0dd7a574b67/SmartHub_Site_Scope'
    },
    dataPrivacy: {
      label: 'Data Privacy',
      url: 'https://discovercontent.ey.net/content/cms/home-page/privacy-policy.html'
    },
    search: {
      sourceId: 'b29924a9-ec32-4c10-8892-a544b69ee121'
    },
    smarthub: {
      apiScope: '0ab2f2cc-69cb-43e1-94eb-c0dd7a574b67/SmartHub_Site_Scope'
    },
    customApi: {
      apiScope: 'api://8dcf0d40-7d03-4fc2-9eca-3f459b14ac67/Api.Read.All'
    },
    smartPreview: {
      previewURL: 'https://DiscoverDocViewer.ey.com'
    },
    webcomponent: {
      cssfile: 'https://discover.ey.com/webcomponent/main.css',
      jsfile: 'https://discover.ey.com/webcomponent/main.js'
    },
    aemPreviewStats:
      'https://discovercontent.ey.net/bin/eyd/aaoc/service/read-data?pageid=$eyId',
    aemBrowseAPI:
      'https://discovercontent.ey.net/bin/eyd/aaoc/service/browse?name=$name',
    isShowNewsVertical: true,
    intranetHostName: ['intranet.ey.com','intranet-cms.ey.com'],
    sharepointHosts: ['sites.ey.com', 'sharepoint.com'],
    isToggleAISearchEnabled: true,
    forceKeywordSearchPeople: true,
    forceKeywordSearchNews: true,
    adobeSDKUrl: 'https://acrobatservices.adobe.com/view-sdk/viewer.js',
    aemPDFRenditionServlet: '/bin/eyd/aaoc/service/assetpdfrendition',
    adobeClientId: 'eb1d52f836c9484d84dcb7ce2b175262'
  },
  prodstg: {
    apiBaseUrl: 'https://api.discovernw.ey.com/discoversearch',
    appBaseUrl: 'https://discover-rel.ey.com',
    aemBaseUrl: 'https://discovercontent.ey.net',
    ontology: {
      BaseUrl: 'https://api.discovernw.ey.com/pp-search',
      limitBy: ['limitby']
    },
    didYouKnowUrl:
      'https://discovercontent.ey.net/bin/eyd/aaoc/service/xf/did-you-know?landingPage=search',
    legacyDiscoverDetailPath:
      'https://find.ey.net/discover/sitepages/home.aspx?detailPath=',
    legacyDiscoverVideoPath:
      'https://find.ey.net/discover/sitepages/video.aspx?detailPath=',
    dataExplorerDetailPath: 'https://data.discover.ey.com/#/details?src=',
    teamsPath: 'https://teams.microsoft.com/l/chat/0/0?users=',
    discoverHeader:
      'https://discovercontent.ey.net/bin/eyd/aaoc/service/xf/header',
    discoverFooter:
      'https://discovercontent.ey.net/bin/eyd/aaoc/service/xf/footer',
    intranetHeader:
      'https://intranet.ey.com/bin/eyd/aaoc/service/xf/header/intranet',
    intranetFooter:
      'https://intranet.ey.com/bin/eyd/aaoc/service/xf/footer/intranet',
    aemScope: 'd8189e08-8225-4287-986c-3ce29b2232b9/AEM.AAOC.Read',
    auth: {
      clientId: '8dcf0d40-7d03-4fc2-9eca-3f459b14ac67',
      tenantId: '5b973f99-77df-4beb-b27d-aa0c70b8482c',
      apiScope: 'api://0ab2f2cc-69cb-43e1-94eb-c0dd7a574b67/SmartHub_Site_Scope'
    },
    dataPrivacy: {
      label: 'Data Privacy',
      url: 'https://discovercontent.ey.net/content/cms/home-page/privacy-policy.html'
    },
    search: {
      sourceId: 'b29924a9-ec32-4c10-8892-a544b69ee121'
    },
    smarthub: {
      apiScope: '0ab2f2cc-69cb-43e1-94eb-c0dd7a574b67/SmartHub_Site_Scope'
    },
    customApi: {
      apiScope: 'api://8dcf0d40-7d03-4fc2-9eca-3f459b14ac67/Api.Read.All'
    },
    smartPreview: {
      previewURL: 'https://DiscoverDocViewer.ey.com'
    },
    webcomponent: {
      cssfile: 'https://discover.ey.com/webcomponent/main.css',
      jsfile: 'https://discover.ey.com/webcomponent/main.js'
    },
    aemPreviewStats:
      'https://discovercontent.ey.net/bin/eyd/aaoc/service/read-data?pageid=$eyId',
    aemBrowseAPI:
      'https://discovercontent.ey.net/bin/eyd/aaoc/service/browse?name=$name',
    isShowNewsVertical: true,
    intranetHostName: ['intranet.ey.com','intranet-cms.ey.com'],
    sharepointHosts: ['sites.ey.com', 'sharepoint.com'],
    isToggleAISearchEnabled: true,
    forceKeywordSearchPeople: true,
    forceKeywordSearchNews: true,
    adobeSDKUrl: 'https://acrobatservices.adobe.com/view-sdk/viewer.js',
    aemPDFRenditionServlet: '/bin/eyd/aaoc/service/assetpdfrendition',
    adobeClientId: 'eb1d52f836c9484d84dcb7ce2b175262'
  }
};

const envName: string | undefined = Object.keys(envConfig).find(
    (key) => key === process.env.REACT_APP_ENVIRONMENT_NAME
);
export const currentEnvironmentName: string = envName || '';
console.log(`Current Environment: ${currentEnvironmentName}`);
export const isLocalOrDevEnv: boolean =
  currentEnvironmentName === 'local' || currentEnvironmentName === 'development';
export default envConfig[envName as keyof EnvConfig];
